















































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import PositionsVue from '@/components/Agencies/Positions.vue';
import PositionDto from '@/models/Positions/PositionDto'
import DateTimeUtils from '@/lib/dateTimeUtils';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import BookingBrowseWorkersSearchCriteria from '@/components/BookingRoleWorkers/BookingBrowseWorkersSearchCriteria.vue';
import BookingBrowseWorkersOfferRole from '@/components/BookingRoleWorkers/BookingBrowseWorkersShortlist.vue';
import BookingBrowseWorkersQuickBook from '@/components/BookingRoleWorkers/BookingBrowseWorkersQuickBook.vue';
import WorkerDto from '@/models/Workers/WorkerDto';
import { AgencyModule } from '@/store/modules/agency';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerProfileTempSummary from '@/components/Workers/WorkerProfileTempSummary.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'BookingBrowseWorkers',
  components: { BookingBrowseWorkersSearchCriteria, BookingBrowseWorkersOfferRole, BookingBrowseWorkersQuickBook, WorkerProfileTempSummary }
})
export default class extends GiganautVue {

	page = 1;
	perPage = 8;

	@Prop()
	selectedBookingRole: BookingRoleDto;

	getWorkerAvatarUrl(worker: WorkerProfileDto) {
		return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + worker.id + "/resized-100/" + worker.avatar;
	}

	get selectedWorkerId() {
		return BookingDetailsModule.browseWorkersVM.selectedWorkerId;
	}

	get selectedWorker() {
		return BookingDetailsModule.browseWorkersVM.selectedWorker;
	}

	get currentBooking() {
		return BookingDetailsModule.currentBooking;
	}

	set selectedWorkerId(id: string) {
		console.log("Settings worker ID to " + id);
		BookingDetailsModule.browseWorkersVM.selectedWorkerId = id;
	}

	@Watch('selectedWorkerId', { immediate: true })
    async onSelectedWorkerIdChanged(val: string, oldVal: string) {
	   if (val !== "") {
		   await BookingDetailsModule.updateSelectedBrowseWorker(val);
	   }
	}


	@Watch('selectedBookingRole', { immediate: true })
    async onSelectedBookingRoleChanged(val: BookingRoleDto, oldVal: BookingRoleDto) {
	   await BookingDetailsModule.updateBrowseSelectedBookingRole(val);
	   if (this.pagedWorkerProfiles.length !== 0) {
			BookingDetailsModule.browseWorkersVM.selectedWorkerId = (this.pagedWorkerProfiles[0].entity.id);
	   }
	}
	
	get workerProfiles() {
		return BookingDetailsModule.browseWorkersVM.workerProfiles;
	}

	get pagedWorkerProfiles() {
		return this.workerProfiles.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}
	
	async onPageChanged(input: number){
		BookingDetailsModule.browseWorkersVM.selectedWorkerId = (this.pagedWorkerProfiles[0].entity.id);
	}

	get loadingWorkers() {
		return BookingDetailsModule.loadingWorkers;
	}

	get roleDatesSummary() {
        let dates = "";
        for (let i=0; i < this.selectedBookingRole.shifts.length; i++) {
            if (i !== 0) {
                dates += ", ";
			}
            dates += DateTimeUtils.toShortDate(new Date(this.selectedBookingRole.shifts[i].startAt));
        }
        return dates;
    }

	async updateSelectedWorkerProfileIds(val: boolean, workerProfileId: string) {
    	if (val) {
			await BookingDetailsModule.addBrowseSelectedWorkerId(workerProfileId)
		} else {
			await BookingDetailsModule.removeBrowseSelectedWorkerId(workerProfileId)
		}
	}
	
	calculateAge(dateOfBirth: Date){
		if (dateOfBirth === null) {
			return "Age Unknown";
		}
		const dob = new Date(dateOfBirth);
		const diff_ms = Date.now() - dob.getTime();
    	const age_dt = new Date(diff_ms); 
  
    	return (Math.abs(age_dt.getUTCFullYear() - 1970) < 18) ? "Under 18" : "";
	}

  	availabilityClass(isAvailable: boolean){
		if (isAvailable) {
			return "available";
		} 
		else {
			return "unavailable";
		}
  }
}
